<ng-container *transloco="let t">
  @if (showNavbar()) {
    @if (offline()) {
      <div class="w-screen bg-yellow-300 flex align-items-center justify-content-center text-center pt-1 pb-1">
        <span class="material-icons-outlined" aria-hidden="true">
          wifi_off
        </span>
        <p class="mb-0 mt-0 font-semibold ml-2">{{ t('offline') }}</p>
      </div>
    }
    <div class="p-menubar p-component" style="padding: .4rem !important;">
      <div class="flex justify-content-between align-items-center">
        <img (click)="router.navigate(['/'])" [src]="data.logo" height="40" class="mr-w2"
          [alt]="t('company_logo')" />
        <h1 (click)="router.navigate(['/'])" (keyup.enter)="router.navigate(['/'])" tabindex="0"
          class="cursor-pointer mb-0 mt-0 ml-3 mr-3 font-semibold text-black-alpha-90 truncate">{{
          data.denominazione }}
        </h1>
        <div class="flex align-items-center">
          <!-- changeLang(currentLang == 'it' ? 'en' : 'it') -->
          @if (data.languages.length > 0) {
            <div class="ml-2 cursor-pointer flex" (click)="menu.toggle($event)">
              <img src="/flags/{{currentLang}}.svg" width="24" alt="{{currentLang}} flag" draggable="false">
            </div>
          }
          <p-tieredMenu #menu [model]="languages" [popup]="true" appendTo="body" />

          <span notifications role="button" aria-label="Apri notifiche" [class.hidden]="!showBell()"
            class="notification-modal-event material-icons-outlined cursor-pointer ml-2"
            (click)="notificationModal.set({ ...notificationModal(), visible: true })" tabindex="0">
            notifications
          </span>
          <span [class.hidden]="showBell()" class="ml-4 mr-1"></span>

        </div>
      </div>
    </div>
  }

  <!-- Message viewer -->
  <p-toast [breakpoints]="{'920px': {width: '100%', right: '0', left: '0'}}"></p-toast>

  <!-- Notification modal -->
  <p-dialog [showHeader]="false" [visible]="notificationModal().visible" 
    (onHide)="notificationModal.set({ ...notificationModal(), visible: false })" 
    [breakpoints]="{ '960px': '75vw' }"
    [style]="{ width: '50vw' }" [modal]="true" [draggable]="false" [resizable]="false">
    @if (pushNotificationService.isSupported()) {
      <div class="text-center">
        <h3>{{ t('notification_modal.title', {name: data.denominazione}) }}</h3>
        <p class="mb-2">{{ t('notification_modal.text', {name: data.denominazione}) }}</p>
      </div>
    }
    @if (!pushNotificationService.isSupported()) {
      <div>
        <p><b>{{ t('notification_modal.install_app') }}</b></p>
        <p class="mb-0 mt-0" [innerHTML]="sanitizer.bypassSecurityTrustHtml(t('download_app_modal.ios_istructions'))"></p>
      </div>
    }
    @if (notificationModal().error) {
      <p-message severity="error" [closable]="false">{{ notificationModal().error }}</p-message>
    }
    <div class="mt-1">
      <form #form="ngForm" novalidate>
        @if (pushNotificationService.isSupported()) {
          <div class="flex align-items-center">
            <p-toggleSwitch [(ngModel)]="notificationModel.webpush" name="notification"></p-toggleSwitch>
            <p class="ml-2 font-bold">{{ t('notification_modal.notification') }}</p>
          </div>
        }
        <!-- <div class="flex align-items-center">
          <p-inputSwitch [(ngModel)]="notificationModel.emailEnabled" name="emailEnabled"></p-inputSwitch>
          <p class="ml-2 font-bold">{{ t('notification_modal.email') }}</p>
        </div>
        <div *ngIf="notificationModel.emailEnabled">
          <input #email="ngModel" class="p-inputtext-sm w-full" placeholder="mario.rossi@gmail.com" type="text"
            name="email" pInputText [(ngModel)]="notificationModel.email"
            pattern="^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$" required />
          <div [hidden]="(email.valid || email.pristine)" class="mt-1"><span class="text-red-500">{{
              t('form.invalid_format') }}</span></div>
        </div> -->
        @if (telegram) {
          <div class="mt-3">
            <a href="https://t.me/{{ telegram.replace('@', '') }}">
              <div class="flex flex-row align-items-center">
                <img src="telegram.png" [alt]="t('telegram_alt_img')" width="20">
                <p class="mb-0 ml-2 mt-0 telegram-style">{{ t('notification_modal.telegram') }}</p>
              </div>
            </a>
          </div>
        }
        <!-- <div class="mt-3" *ngIf="notificationModel.emailEnabled">
          <p-checkbox [(ngModel)]="notificationModel['privacy_consent']" [required]="true" [binary]="true"
            inputId="privacy"></p-checkbox>
          <label class="ml-2"
            [innerHTML]="t('notification_modal.privacy_tos', {link_privacy_policy: config?.link_privacy_policy})"
            for="privacy"></label>
        </div> -->
      </form>
      <div class="flex flex-row justify-content-end align-items-center mt-2">
        <p-button [label]="t('ok')"
          [disabled]="!form.valid || !(!notificationModel.emailEnabled || (notificationModel.emailEnabled && notificationModel['privacy_consent'] == true))"
          [loading]="notificationModal().loading" (keyup.enter)="notificationClick($event)"
          (onClick)="notificationClick($event)"
          [attr.aria-disabled]="!form.valid || !(!notificationModel.emailEnabled || (notificationModel.emailEnabled && notificationModel['privacy_consent'] == true))"></p-button>
        <p-button class="ml-2" severity="secondary" [label]="t('close')"
          (keyup.enter)="notificationModal.set({ ...notificationModal(), visible: false })"
          (onClick)="notificationModal.set({ ...notificationModal(), visible: false })"></p-button>
      </div>
    </div>
  </p-dialog>

  <!-- Banner modal -->
  <!-- <p-dialog [showHeader]="false" [visible]="bannerPWAModal()" (onHide)="bannerPWAModal.set(false)" [breakpoints]="{ '960px': '75vw' }"
    [style]="{ width: '33vw' }" [modal]="true" [draggable]="false" [resizable]="false" [styleClass]="'bg-gray-custom'">
    <div class="mt-5">
      <div class="text-center">
        <a href="{{config.pwa_banner_link}}" target="_blank">
          <figure class="m-0 p-0">
            <img class="w-full" alt="banner-register" [src]="config.pwa_banner">
          </figure>
        </a>
      </div>
      <div class="flex flex-row justify-content-end align-items-center mt-2">
        <p-button [label]="'Prova'" (onClick)="goToLink(config.pwa_banner_link)"
          (keyup.enter)="goToLink(config.pwa_banner_link)"></p-button>
        <p-button class="ml-2" severity="secondary" [label]="t('close')" (onClick)="bannerPWAModal = false"
          (keyup.enter)="bannerPWAModal = false"></p-button>
      </div>
    </div>
  </p-dialog> -->

  <!-- Banner modal -->
  <p-dialog [showHeader]="false" [visible]="bannerPWAModal()" (onHide)="bannerPWAModal.set(false)" [breakpoints]="{ '960px': '75vw' }"
    [style]="{ width: '33vw' }" [modal]="true" [draggable]="false" [resizable]="false" [styleClass]="'bg-gray-custom'">
    <div class="mt-5">
      <div class="text-center">
        <a href="{{config.pwa_banner_link}}" target="_blank">
          <figure class="m-0 p-0">
            <img class="w-full" alt="banner-register" [src]="config.pwa_banner">
          </figure>
        </a>
      </div>
      <div class="flex flex-row justify-content-end	align-items-center mt-2">
        <p-button [label]="'Prova'" (onClick)="goToLink(config.pwa_banner_link)"></p-button>
        <p-button class="ml-2" severity="info" [label]="t('close')" (onClick)="bannerPWAModal.set(false)"></p-button>
      </div>
    </div>
  </p-dialog>
</ng-container>